import { render, staticRenderFns } from "./GridOffer.vue?vue&type=template&id=b6189112&scoped=true"
import script from "./GridOffer.vue?vue&type=script&setup=true&lang=ts"
export * from "./GridOffer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GridOffer.vue?vue&type=style&index=0&id=b6189112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6189112",
  null
  
)

export default component.exports